import { Messages as Message } from "../UI";
export function setToken(key, token) { // 设置存储token
  // 顶级域名判断
  let domain = isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
  addCookieAndDomain(key, token, 2, domain);
  if (localStorage) {
    localStorage.setItem(key, token);
  }
}
// 设置cookie token
function addCookieAndDomain(key, value, objHours, strdomain) {
  let str = key + '=' + value + ';domain=' + strdomain;
  if (objHours > 0) {
    let date = new Date();
    let ms = objHours * 3600 * 1000;
    date.setTime(date.getTime() + ms);
    str += ';expires=' + date.toGMTString() + ';path=/';
  } else {
    str += ';path=/';
  }
  document.cookie = str;
}


// 删除token
export function removeToken() {
  clearCookie();
  return localStorage.clear()
}
function clearCookie() {
  // eslint-disable-next-line no-useless-escape
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  // 顶级域名判断
  let domain = isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + ';domain=' + domain;
    }
  }
}

// 获取token
export function getToken(key) {
  return localStorage.getItem(key)
  // let cookieStr = document.cookie
  // if (cookieStr.length > 0) {
  //   let arrCookie = cookieStr.split("; ")
  //   for (const val of arrCookie) {
  //     let arr = val.split("=")
  //     if (arr[0] === key) {
  //       return arr[1]
  //     }
  //   }
  // }
  // return ""
}

// 设置cookie
export function setCookieVal(key, val, time = 2) {
  // 顶级域名判断
  let domain = isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
  addCookieAndDomain(key, val, time, domain);
}

// 获取cookie
export function getCookieVal(key) {
  let cookieStr = document.cookie

  if (cookieStr.length > 0) {
    let arrCookie = cookieStr.split("; ")

    for (const val of arrCookie) {
      let arr = val.split("=")
      if (arr[0] === key) {

        return arr[1]
      }
    }
  }
  return ""
}

/**
 * 下载文件
 * @param {String} url 下载地址
 * @param {String} filename 文件名
 */
export function downloadFile(url, filename,type,num) {
  window.log.singleLog("ai_download_all", { name: filename })
  console.log(url);
  
  if(url.includes('?')){
    url+='&'+new Date().getTime()
  }else{
    url+='?'+new Date().getTime()
  }
  // url= url.includes('?') ? (url+'&'+new Date().getTime()):(url+'?'+new Date().getTime())
  fetch(url, { credentials: 'omit' })
   .then(response => response.blob())
   .then(blob => {
    
    let obj={
      png: 'image/png',
      odd: 'application/vnd.oasis.opendocument.text',
      gif: 'image/gif',
      jpeg: 'image/jpeg',
      jpg: 'image/jpeg',
      bmp: 'image/bmp',
      svg: 'image/svg+xml',
      ico: 'image/x-icon',
      webp: 'image/webp',
      tiff: 'image/tiff', // TIFF 图像文件
      psd: 'image/vnd.adobe.photoshop', // Photoshop 文件
    }
    !type?type='png':''
      // 创建一个 Blob 对象，用于保存图片数据
      const file = new Blob([blob], { type: obj[type] });
      // 使用 FileSaver.js 保存文件
      saveAs(file, filename);
    })
   .catch(error => console.error('下载图片时出现错误：', error));
   if(num!='Multiple'){
    Message({
      type: "success",
      message: "图片正在下载中，下载成功后自动保存到本地，请稍后查看！",
    })
   }
   

}

function addZero(num) {
  if (num < 10) {
    return '0' + num;
  } else {
    return num;
  }
}

/**
 * 获取当前时间
 * @param {String} type 类型 date 日期 time 时间
 * @returns {String} yyyy-MM-dd HH:mm:ss Or yyyy-MM-dd
 */
export function getCurTimeFormat(type) {
  let date = new Date();
  let year = date.getFullYear();
  let month = addZero(date.getMonth() + 1);
  let day = addZero(date.getDate());
  let hours = addZero(date.getHours());
  let minutes = addZero(date.getMinutes());
  let seconds = addZero(date.getSeconds());
  if (type === 'date') {
    return year + '-' + month + '-' + day;
  }
  let curTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  return curTime;
}

/**
 * 时间戳转日期
 * @param {Number} timestamp 时间戳
 * @param {String} type 类型 date 日期 time 时间
 * @returns {String} yyyy-MM-dd HH:mm:ss Or yyyy-MM-dd
 */
export function timestampFormat(timestamp, type) {

  let date = new Date(timestamp);
  let year = date.getFullYear();
  let month = addZero(date.getMonth() + 1);
  let day = addZero(date.getDate());
  let hours = addZero(date.getHours());
  let minutes = addZero(date.getMinutes());
  let seconds = addZero(date.getSeconds());
  if (type === 'date') {
    return year + '-' + month + '-' + day;
  }
  let curTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  return curTime;
}

/**
 * 左右平滑滚动
 * @param {Element} container 滚动容器
 * @param {Number} scrollAmount 滚动距离
 * @param {Number} duration 滚动时间
 */
export function smoothScroll(container, scrollAmount, duration) {
  const start = container.scrollLeft;
  const target = start + scrollAmount;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1); // 计算进度

    // 使用缓动函数生成平滑效果
    const ease = progress * (2 - progress);
    container.scrollLeft = start + (target - start) * ease;

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}

/**
 * 判断容器是否滚动到底部
 * @param {Element} container 滚动容器
 * @param {Number} threshold 阈值（可选，默认为0）
 * @returns {Boolean} 是否滚动到底部
 */
export function isScrollBottom(container, threshold = 0) {
  // 获取容器的滚动高度、可见高度和内容高度
  const scrollHeight = container.scrollHeight; // 内容总高度
  const clientHeight = container.clientHeight; // 可视区域高度
  const scrollTop = container.scrollTop; // 当前滚动距离

  // 判断是否滚动到底部，加上阈值
  return scrollTop + clientHeight >= scrollHeight - threshold;
}

/**
 * 防抖函数
 * @param {Function} fn 要防抖的函数
 * @param {Number} delay 延迟时间（毫秒）
 * @returns {Function} 返回一个防抖处理后的函数
 */
export function debounce(fn, delay) {
  let timer = null;

  return function (...args) {
    // 清除上一个定时器
    if (timer) {
      clearTimeout(timer);
    }
    // 设置新的定时器
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}